import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { filter, take } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { InterventionInstanceStore } from '../../../store/intervention-instance/component-store/intervention-instance.store';
import { HttpResponse } from '@angular/common/http';
import { UserInterface } from 'src/app/models/interface/user.interface';
import { InterventionInterface } from 'src/app/models/interface/intervention.interface';
import { InterventionInstanceInterface } from 'src/app/models/interface/intervention-instances/intervention-instance.interface';

export type DialogInterventionInstanceCancelDataParam = {
  intervention_name: string;
};
export type DialogInterventionInstanceCancelData = {
  param: DialogInterventionInstanceCancelDataParam;
  collaborators: UserInterface[];
  intervention: InterventionInterface;
  members: UserInterface[];
  isManager: boolean;
  instance: InterventionInstanceInterface;
};

export type DialogInterventionInstanceCancelResult = undefined | 'CANCELED' | 'SUCCESS';

type ResponseData = 'DEFAULT' | 'LOADING' | 'SUCCESS' | 'FAILURE';

@Component({
  selector: 'app-dialog-intervention-instance-cancel',
  templateUrl: './dialog-intervention-instance-cancel.component.html',
  styleUrls: ['./dialog-intervention-instance-cancel.component.scss'],
  providers: [InterventionInstanceStore],
})
export class DialogInterventionInstanceCancelComponent implements OnInit, OnDestroy {

  public isManager: boolean;

  intervention: InterventionInterface;
  instance: InterventionInstanceInterface;
  collaborators: UserInterface[];
  members: UserInterface[];

  public setCanceledResponse = new BehaviorSubject<ResponseData>('DEFAULT');

  public param: DialogInterventionInstanceCancelDataParam;

  private updateInstanceStateResponse$: Observable<any>;

  private subscriptions: Subscription[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogInterventionInstanceCancelData,
    private interventionInstanceStore: InterventionInstanceStore,
    private dialogRef: MatDialogRef<DialogInterventionInstanceCancelComponent, DialogInterventionInstanceCancelResult>,
  ) {
    this.updateInstanceStateResponse$ = this.interventionInstanceStore.updateInstanceStateResponse$;
  }

  ngOnInit(): void {
    this.param = this.data.param;
    this.isManager = this.data.isManager;
    this.intervention = this.data.intervention;
    this.instance = this.data.instance;
    this.collaborators = this.data.collaborators;
    this.members = this.data.members;
  }

  public setCanceled(): void {
    if (this.setCanceledResponse.value !== 'DEFAULT') {
      return;
    }
    this.setCanceledResponse.next('LOADING');
    if (this.isManager) {
      this.interventionInstanceStore.updateInstanceStateEM({
        instanceId: this.instance.id,
        state: 'canceled',
      });
    } else {
      this.interventionInstanceStore.updateInstanceState({
        instanceId: this.instance.id,
        state: 'canceled',
      });
    }
    this.subscriptions.push(
      this.updateInstanceStateResponse$
        .pipe(
          filter((value) => !!value),
          take(1),
        )
        .subscribe((value: any) => {
          if (value instanceof HttpResponse) {
            this.setCanceledResponse.next('SUCCESS');
            setTimeout(() => {
              this.dialogRef.close('SUCCESS');
            }, 2500);
          } else {
            this.setCanceledResponse.next('FAILURE');
            setTimeout(() => {
              this.setCanceledResponse.next('DEFAULT');
            }, 2500);
          }
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
